// @ts-nocheck
import { workerIcon } from '@/lib/map-control/marker/icon';
import { includedWorkerFilter } from '@/lib/map-control/helper';
import Marker from './Marker';
export default class WorkerMarker extends Marker {
    #type = 'worker';
    isShareWorker = false;
    constructor(workerData, naver, hubControlMap) {
        super(naver, hubControlMap);
        const { user, location, orderInfo, isShareWorker, relatedWeight, } = workerData;
        const { code } = user;
        this.id = code;
        this.workerCode = code;
        this.latLng = [
            location.latitude,
            location.longitude,
        ];
        this.isShareWorker = isShareWorker;
        this.origin = this.mapControlState.workerList[this.workerCode];
        this.icon = workerIcon({
            naver: this.naver,
            id: code,
            code,
            name: user.name,
            attendCode: user.attendCode,
            orderInfo,
            relatedWeight,
            isShareWorker,
        });
    }
    deleteMarker() {
        this.mapMarkerList.workers.deleteMarker(this.workerCode);
    }
    /**
     * 워커 마커 지도 노출 여부 판단
     * @returns {boolean}
     */
    computeIsShow() {
        const { id, isShareWorker, isActive, } = this;
        const workerData = this.mapControlState.workerList[id];
        const selectedWorkerFilter = this.hubControlMap.workerFilter;
        const pos = this.getPosition();
        const relatedWeight = this.getRelatedWeight();
        const { isHideShareWorker, isHideWorkerMarker, } = this.mapControlState.mapVisibilitySetting;
        // 이 타이밍에 워커 데이터 없을 수 있음.
        if (!workerData) {
            return false;
        }
        // 활성화 or 가중치 있으면 무조건 노출
        if (isActive || relatedWeight) {
            return true;
        }
        // 마커 숨김시 비노출
        if (isHideWorkerMarker) {
            return false;
        }
        // 공유라이더는 공유숨김이면 비노출
        if (isShareWorker && isHideShareWorker) {
            return false;
        }
        // 영역안에 없으면 비노출
        if (!this.bounds.hasBounds(pos, this.mapControl.mapBoundary.OUTSIDE)) {
            return false;
        }
        // 필터에 포함 안되면 비노출
        if (!includedWorkerFilter(workerData, selectedWorkerFilter)) {
            return false;
        }
        // 모두 통과시 노출
        return true;
    }
    /**
     * 워커 마커 데이터 업데이트 + 노출 / 비노출 / 제거
     * @param {boolean} isActive 활성여부 null = 기존값 이용
     */
    updateMarker({ isActive: _isActive = null, } = {
        _isActive: null,
    }) {
        const { user, orderInfo, isShareWorker, } = this.mapControlState.workerList[this.id];
        this.isActive = typeof _isActive === 'boolean' ? _isActive : this.isActive;
        this.relatedWeight = this.getRelatedWeight();
        const isShow = this.computeIsShow();
        if (isShow) {
            this.updatePosition();
            this.setMap(this.mapInstance);
        }
        else {
            this.setMap(null);
        }
        // 아이콘 관련 로직
        const iconOptions = workerIcon({
            naver: this.naver,
            id: user.id,
            code: user.code,
            name: user.name,
            attendCode: user.attendCode,
            orderInfo,
            isShareWorker,
            isActive: this.isActive,
            relatedWeight: this.relatedWeight,
        });
        this.setIcon(iconOptions);
    }
    /**
     * 워커 마커 초기화
     * @param {boolean} isDeleteMarker 마커 삭제 여부
     * @returns
     */
    deactivateMarker(isDeleteMarker) {
        const workerData = this.mapControlState.workerList[this.workerCode];
        if (!workerData) {
            return;
        }
        const { orderInfo } = workerData;
        // 워커의 주문 처리 로직
        orderInfo.forEach(({ orderId, }) => {
            // TODO 워커 주문 배달내역에서 채크 로직 (워커 주문을 배달내역 기준으로 변경 리팩토링 필요)
            const orderData = this.mapControlState.orderList[orderId];
            if (!orderData) {
                return;
            }
            const { storeId } = orderData;
            const mkDrop = this.mapMarkerList.drops.getMarker(orderId);
            const mkStore = this.mapMarkerList.stores.getMarker(storeId);
            // 가중치 제거
            this.mapMarkerList.updateOrderMarkerWeight(orderId, true);
            // 주문
            if (mkDrop) {
                mkDrop.unhighlight();
                mkDrop.updateMarker({
                    isActive: false,
                });
            }
            // 상점
            if (mkStore) {
                mkStore.unhighlight();
                mkStore.updateMarker();
            }
        });
        // 가중치 보정. 주문 없을 경우를 위한 가중치 감소
        if (workerData.isEmptyOrder()) {
            this.updateRelatedWeight(true);
        }
        this.unhighlight();
        this.updateMarker({
            isActive: false,
        });
        if (isDeleteMarker) {
            this.deleteMarker();
        }
    }
    /**
     * 워커 활성 활성 + 워커가 배차한 주문
     * @returns {any}
     */
    activateMarker() {
        const workerData = this.mapControlState.workerList[this.workerCode];
        const { orderInfo } = workerData;
        // 워커의 주문 처리 로직
        orderInfo.forEach(({ orderId, }) => {
            const orderData = this.mapControlState.orderList[orderId];
            // TODO 없으면 안되지만 없을 수 있음... 임시 https://www.notion.so/barogohq/d6021ca7f2954f85bc48cd00aedf7443
            if (!orderData) {
                console.log(`[activateMarker] Not exist Order. Id: ${orderId}`);
                return;
            }
            // TODO 현재 주문 상태를 워커 푸시와 주문 푸시 양측에 의존하고 있음. 때문에 과도기적으로 주문상태를 보고 판단.
            // 후에 주문 기준으로만 변경시 제거 필요
            // 아직 접수건이라면 무시.
            if (orderData.isAccepted) {
                console.log('[activateMarker] Still Accepted', orderData);
                return;
            }
            const { storeId } = orderData;
            const mkDrop = this.mapMarkerList.drops.getMarker(orderId);
            const mkStore = this.mapMarkerList.stores.getMarker(storeId);
            // TODO 워커 선택시 나온 주문은 필터를 무시한다. 안정화 되면 제거 예정 20230531
            // 주문 필터 적용
            // if (
            //   this.orderFilter !== this.mapControl.mapControlAttendCode.ALL.code
            //     && !this.helper.isIncludedCurrentFilter(statusCode, this.hubControlMap.orderFilter)
            // ) {
            //   return;
            // }
            // 가중치
            this.mapMarkerList.updateOrderMarkerWeight(orderId);
            // 주문
            mkDrop.highlight();
            mkDrop.updateMarker();
            // 상점
            mkStore.highlight();
            mkStore.updateMarker();
        });
        // 워커
        this.highlight();
        this.updateMarker({
            isActive: true,
        });
    }
}
